import { GeneralAttributeResourceCalculationKeyBase } from './base/general-attribute-resource-calculation-key-base';

export class GeneralAttributeResourceCalculationKey extends GeneralAttributeResourceCalculationKeyBase { }